import { BulkResizeImage } from "store/features/bulkResize/types";
import { Dimension } from "store/types/resizeSettings";
import { Unit } from "store/types/unit";
import { validateResizeDimension } from "client/utils/validateResizeDimension";

export const MAX_RESIZE_SIZE_IN_PX = 20000;

export const validateResizeDimensions = (
    images: BulkResizeImage[],
    dimensionType: Dimension,
    unit: Unit,
    percentage: number = 100,
    dpi?: number,
): boolean => {
    let isValid = true;

    images.forEach((image) => {
        if (!validateResizeDimension(image, dimensionType, unit, percentage, MAX_RESIZE_SIZE_IN_PX, dpi)) {
            isValid = false;
        }
    });

    return isValid;
};
